import { render, staticRenderFns } from "./regionStatisDetails.vue?vue&type=template&id=31f5d857&scoped=true"
import script from "./regionStatisDetails.vue?vue&type=script&lang=js"
export * from "./regionStatisDetails.vue?vue&type=script&lang=js"
import style0 from "./regionStatisDetails.vue?vue&type=style&index=0&id=31f5d857&prod&lang=scss&scoped=true"
import style1 from "./regionStatisDetails.vue?vue&type=style&index=1&id=31f5d857&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f5d857",
  null
  
)

export default component.exports